import React, { useState, useEffect } from 'react';
import './PaymentModal.css';
import { message } from 'antd';

export const PaymentModal = ({ isOpen, onClose }) => {
  const [packages, setPackages] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [pricePerCredit, setPricePerCredit] = useState(0);

  const baseUrl = process.env.REACT_APP_API_URL || '';

  // Получить доступные пакеты
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/payments/available-packages`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch packages');
        }
        
        const data = await response.json();
        const list = Array.isArray(data) ? data : (data.packages || []);
        setPackages(list);
        if (list.length > 0) {
          const minPrice = Math.min(...list.map(pkg => pkg.price / pkg.quantity));
          setPricePerCredit(minPrice);
        } else {
          setPricePerCredit(60); // дефолт
        }
      } catch (error) {
        console.error('Error fetching packages:', error);
      }
    };

    if (isOpen) {
      fetchPackages();
    }
  }, [isOpen, baseUrl]);

  const handlePurchase = async () => {
    if (!quantity || quantity <= 0) return;

    const amount = Math.ceil((pricePerCredit || 60) * quantity);

    setIsLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/payments/create-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          amount: amount,
          quantity: quantity,
        }),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error('Create payment error response:', errText);
        throw new Error('Failed to create payment');
      }

      const data = await response.json();
      
      if (data.confirmation_url) {
        window.location.href = data.confirmation_url;
      } else {
        throw new Error('No confirmation URL received');
      }
    } catch (error) {
      console.error('Error creating payment:', error);
      onClose();
      message.info('Оплата пока не работает, извините.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="payment-modal-close" onClick={onClose}>&times;</button>
        <h2 className="payment-modal-title">Покупка обработок документов</h2>

        <div className="payment-custom-quantity">
          <label htmlFor="creditsQuantity">Количество обработок</label>
          <input
            id="creditsQuantity"
            type="number"
            min="1"
            value={quantity}
            onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 1)}
          />
          <p className="payment-total-price">Итого: {Math.ceil((pricePerCredit || 60) * quantity)} ₽</p>
        </div>

        <div className="payment-modal-buttons">
          <button
            className="payment-button primary"
              onClick={handlePurchase}
            disabled={quantity<=0 || isLoading}
          >
            {isLoading ? 'Обработка...' : 'Купить'}
          </button>
          <button className="payment-button secondary" onClick={onClose}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}; 